export enum REDUCER_NAMES {
    GAMES_SEARCH_REDUCER = 'gamesSearchReducer',
    JACKPOTS_REDUCER = 'jackpotsReducer',
    BINGO_SCHEDULE_REDUCER = 'bingoScheduleReducer',
    CUSTOM_USER_REDUCER = 'customUserReducer'
}
